module.exports = function() {
  return new Worker(__webpack_public_path__ + "0e5672768484091700d3.worker.js");
};